"use strict";
// Kit domain types. Deps-free leaf: this folder imports nothing outside
// itself so web, restServer, and all three plugins can depend on it without
// dragging in the rest of `shared` (same discipline as ADR-0005 runnitFields
// and ADR-0016 analytics).
//
// See CONTEXT.md "Kits" for the domain language: Kit, Kit Type, Kit Tag,
// Kit Tool Label.
Object.defineProperty(exports, "__esModule", { value: true });
exports.KIT_TOOL_LABEL_TYPE = exports.KIT_SURFACES = exports.isKitType = exports.KIT_TYPES = exports.KIT_TYPE = void 0;
exports.KIT_TYPE = {
    image: 'image',
    video: 'video',
    imageEdit: 'imageEdit',
    videoEdit: 'videoEdit',
    upscale: 'upscale',
    // Quoted key: an identifier cannot start with a digit, so this kit is
    // always reached as KIT_TYPE['3d'], unlike its dot-accessed siblings.
    '3d': '3d',
};
/** Kit Types in their canonical declaration order (fallback when sortOrder ties). */
exports.KIT_TYPES = [
    exports.KIT_TYPE.image,
    exports.KIT_TYPE.video,
    exports.KIT_TYPE.imageEdit,
    exports.KIT_TYPE.videoEdit,
    exports.KIT_TYPE.upscale,
    exports.KIT_TYPE['3d'],
];
const isKitType = (value) => typeof value === 'string' && Object.prototype.hasOwnProperty.call(exports.KIT_TYPE, value);
exports.isKitType = isKitType;
exports.KIT_SURFACES = ['web', 'photoshop', 'miro', 'revit', 'rhino', 'omniverse'];
exports.KIT_TOOL_LABEL_TYPE = {
    DEFAULT: 'DEFAULT',
    HIGHLIGHT: 'HIGHLIGHT',
    POPULAR: 'POPULAR',
};
